// The Alloy "A" mark — two strokes (steel-light + Alloy blue) fused at a weld
// node, representing separate wallet providers bonded into one control
// plane. Reproduced from the validated brand asset (prototype/assets/brand/
// AlloyBuild_Brand.svg and prototype/assets/auth/brand-logo.png), not a
// Figma-dependent guess — see analysis/AUTH_PROTOTYPE_VS_REACT_AUDIT.md §F.
export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 128 128" aria-hidden role="img">
      <rect width="128" height="128" rx="28" fill="#0A1628" />
      <path d="M28 104 L58 26" stroke="#F1F5F9" strokeWidth="14" strokeLinecap="round" />
      <path d="M70 26 L100 104" stroke="#0052FF" strokeWidth="14" strokeLinecap="round" />
      <path d="M40 76 H88" stroke="#F1F5F9" strokeWidth="12" strokeLinecap="round" />
      <circle cx="64" cy="22" r="10" fill="#0052FF" />
    </svg>
  );
}

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <BrandMark />
      <div className="leading-tight">
        <div className={compact ? "text-lg" : "text-[20px]"}>
          <span className="font-extrabold tracking-tight text-ink">Alloy</span>
        </div>
      </div>
    </div>
  );
}